class e {
  constructor() {
    this.decimalSeparator = ".";
  }
  zipcode(r) {
    return r = r.replace(/[^a-zA-Z0-9]/g, ""), r.match(/^[a-zA-Z][0-9]/) ? r.match(/^[a-zA-Z][0-9]{2}[a-zA-Z]/) ? "** ***" : "*** ***" : r.match(/^[a-zA-Z]{2}[0-9]{2}[a-zA-Z]/) ? "*** ***" : "**** ***";
  }
  birthdate() {
    return "39-19-2999";
  }
}
export {
  e as default
};
